import DataBoxes from "./DataBoxes";

export default DataBoxes;